var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent-modal"},[_c('div',{staticClass:"modal"},[_vm._t("icon"),_vm._t("content"),_vm._t("custom-message"),_c('div',{staticClass:"flex w-full gap-5"},[_vm._t("first-btn"),_vm._t("second-btn"),_vm._t("third-btn")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }